import { create } from 'zustand';

export const useDownloadStore = create((set) => ({
    progress: 0,
    isDownloading: false,
    controller: null,

    startDownload: (controller) => set({ isDownloading: true, controller }),
    setProgress: (progress) => set({ progress }),
    finishDownload: () => set({ isDownloading: false, progress: 0, controller: null }),
    cancelDownload: () => {
        set((state) => {
            if (state.controller) state.controller.abort();
            return { isDownloading: false, progress: 0, controller: null };
        });
    },
}));
